module.exports = __webpack_public_path__ + "img/38_16.48d30d5d.png";